import { useQuery, PATH, Call } from '../../../services/NetworkManager';

// Uses the normal NetworkManager client (auth headers applied), not the
// plain bonds fetch client.
export function getDownsellingYieldRange({ queryKey }) {
  const ipcId = queryKey[1];
  return Call({
    method: 'get',
    path: PATH.bondscannerGetDownsellingYieldRange.replace('{{IPC_ID}}', ipcId),
  });
}

export function useBondscannerYieldRange(ipcId?: string) {
  const { data, isLoading } = useQuery(
    ['bondscannerYieldRange', ipcId],
    getDownsellingYieldRange,
    { enabled: !!ipcId },
  );
  // `Call` resolves to the response body, so the range is at data?.isins
  return { data, isLoading };
}
